import { render, staticRenderFns } from "./TeamDetails.vue?vue&type=template&id=66b28374"
import script from "./TeamDetails.vue?vue&type=script&lang=js"
export * from "./TeamDetails.vue?vue&type=script&lang=js"
import style0 from "./TeamDetails.vue?vue&type=style&index=0&id=66b28374&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports